/*
 * @Description: 流程列表管理
 * @Author: wangwangwang
 * @Date: 2020-08-06 10:30:49
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-09-11 11:14:14
 */
import request from '@/utils/request'
export const Download = "/workflow/system/sign/process/manager/export";

export function queryPage(data) {
  return request({
    url: '/workflow/system/sign/process/manager/query_page',
    method: 'post',
    data
  })
}

export function batchUpdateOrDelete(data) {
  return request({
    url: '/workflow/system/sign/process/manager/batch_update_or_delete',
    method: 'post',
    data
  })
}
